<property-tabs (tabChanged)="tabChanged($event)" [propertyStatus]="status">
  <router-outlet></router-outlet>
  <div class="buttons mx-4 mb-4 is-justify-content-end pt-4">
    <ng-container *ngIf="!isReadonly">
      <button
        [disabled]="isLoading"
        type="button"
        (click)="save(false)"
        class="button is-success mb-0"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
      <button
        [disabled]="isLoading"
        *ngIf="status === 'OBJECTION' && this.getField(['appeal'])"
        type="button"
        (click)="toggleModal('ASSESSMENT')"
        class="button is-danger mb-0"
        translationEditableDirective="SEND_BACK_TO_ASSESSMENT"
      >
        {{ 'SEND_BACK_TO_ASSESSMENT' | translate }}
      </button>

      <button
        [disabled]="isLoading"
        *ngIf="status === 'ASSESSMENT' && !this.getField(['appeal'])"
        type="button"
        (click)="toggleModal('DATA_ENTRY')"
        class="button is-danger mb-0"
        translationEditableDirective="SEND_BACK_TO_DATA_ENTRY"
      >
        {{ 'SEND_BACK_TO_DATA_ENTRY' | translate }}
      </button>

      <ng-template
        *ngIf="status === 'BILLING' && tab !== 'payments'"
        ngxPermissionsOnly="PROPERTY_ACTION_SEND_TO_OBJECTION"
      >
        <button
          [disabled]="isLoading"
          type="button"
          (click)="
            this.getField(['appeal']) || status === 'BILLING'
              ? toggleModal(nextStatus)
              : save(true)
          "
          class="button is-danger mb-0"
        >
          <span
            [translationEditableDirective]="'SEND_TO_' + nextStatus"
            class="mr-1"
          >
            {{ 'SEND_TO_' + nextStatus | translate }}
          </span>
        </button>
      </ng-template>

      <ng-container
        *ngIf="
          (status === 'ASSESSMENT' || status === 'DATA_ENTRY') &&
          this.getField(['assessibility', 'name']) !== 'NOT_ASSESSABLE' &&
          !!nextStatus
        "
      >
        <button
          [disabled]="isLoading"
          type="button"
          (click)="
            this.getField(['appeal']) ? toggleModal(nextStatus) : save(true)
          "
          *ngIf="status !== 'OBJECTION' && tab !== 'payments'"
          class="button mb-0"
          [ngClass]="{
            'is-danger': status === 'BILLING',
            'is-info': status !== 'BILLING'
          }"
        >
          <span
            [translationEditableDirective]="'SEND_TO_' + nextStatus"
            class="mr-1"
          >
            {{ 'SEND_TO_' + nextStatus | translate }}
          </span>
        </button>
      </ng-container>

      <ng-container
        *ngIf="
          status !== 'BILLING' &&
          status !== 'ASSESSMENT' &&
          status !== 'DATA_ENTRY' &&
          !!nextStatus
        "
      >
        <button
          [disabled]="isLoading"
          type="button"
          (click)="
            this.getField(['appeal']) ? toggleModal(nextStatus) : save(true)
          "
          *ngIf="status !== 'OBJECTION' && tab !== 'payments'"
          class="button mb-0"
          [ngClass]="{
            'is-danger': status === 'BILLING',
            'is-info': status !== 'BILLING'
          }"
        >
          <span
            [translationEditableDirective]="'SEND_TO_' + nextStatus"
            class="mr-1"
          >
            {{ 'SEND_TO_' + nextStatus | translate }}
          </span>
        </button>
      </ng-container>
      <ng-template ngxPermissionsOnly="PROPERTY_ACTION_SEND_TO_OBJECTION">
        <button
          [disabled]="isLoading"
          type="button"
          (click)="toggleModal('OBJECTION')"
          *ngIf="status === 'ASSESSMENT' && this.getField(['appeal'])"
          class="button is-warning mb-0"
          translationEditableDirective="SEND_TO_OBJECTION"
        >
          {{ 'SEND_TO_OBJECTION' | translate }}
        </button>
      </ng-template>

      <button
        [disabled]="isLoading"
        type="button"
        (click)="toggleFieldVisitModal()"
        class="button is-warning mb-0"
        *ngIf="status === 'OBJECTION' && getField(['appeal'])"
        translationEditableDirective="FIELD_VISIT"
      >
        {{ 'FIELD_VISIT' | translate }}
      </button>

      <alert
        #archiveAlert
        (confirm)="archive()"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
        confirmButtonTextTrnKey="YES_ARCHIVE_IT"
      />
      <button
        [disabled]="isLoading"
        type="button"
        (click)="archiveAlert.fire()"
        class="button is-danger mb-0"
        translationEditableDirective="ARCHIVE"
        *ngxPermissionsOnly="['PROPERTY_ACTION_ARCHIVE']"
      >
        {{ 'ARCHIVE' | translate }}
      </button>

      <div class="control">
        <a
          [routerLink]="['/properties', propertiesTabToNavigate]"
          class="delete"
        ></a>
      </div>
    </ng-container>
    <div class="control" *ngIf="isReadonly">
      <a
        [routerLink]="['/properties', status.toLowerCase()]"
        class="button is-link mb-0"
        translationEditableDirective="BACK_TO_PROPERTIES"
        >{{ 'BACK_TO_PROPERTIES' | translate }}</a
      >
    </div>
  </div>
</property-tabs>

<div class="modal is-active" *ngIf="isModalOpen">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="ENTER_MANDATORY_DETAILS"
        >{{ 'ENTER_MANDATORY_DETAILS' | translate }}</span
      >
      <button
        class="delete"
        (click)="toggleModal()"
        aria-label="close"
        type="button"
      ></button>
    </div>
    <form class="modal-card-body">
      <div *ngIf="showReturnReason" class="field">
        <label class="label" translationEditableDirective="RETURN_REASON">{{
          'RETURN_REASON' | translate
        }}</label>
        <div class="control">
          <textarea
            class="textarea"
            [rows]="4"
            name="returnReason"
            type="text"
            [ngClass]="{ 'is-danger': hasError('returnReason') }"
            (input)="handleFieldChange($event)"
            >{{ getField(['returnReason']) }}</textarea
          >
        </div>
        <p class="help is-danger" *ngIf="hasError('returnReason')">
          {{ getError('returnReason') }}
        </p>
      </div>
      <div *ngIf="showAppealReason" class="field">
        <label class="label" translationEditableDirective="APPEAL_REASON">{{
          'APPEAL_REASON' | translate
        }}</label>
        <div class="control">
          <textarea
            class="textarea"
            [rows]="4"
            name="appealReason"
            type="text"
            [ngClass]="{ 'is-danger': hasError('appealReason') }"
            (input)="handleFieldChange($event)"
            >{{ getField(['appealReason']) }}</textarea
          >
        </div>
        <p class="help is-danger" *ngIf="hasError('appealReason')">
          {{ getError('appealReason') }}
        </p>
      </div>
      <div class="field">
        <label class="label" translationEditableDirective="APPEAL_NOTE">{{
          'APPEAL_NOTE' | translate
        }}</label>
        <div class="control">
          <textarea
            class="textarea"
            [rows]="4"
            name="appealNote"
            type="text"
            [ngClass]="{ 'is-danger': hasError('appealNote') }"
            (input)="handleFieldChange($event)"
            >{{ getField(['appealNote']) }}</textarea
          >
        </div>
        <p class="help is-danger" *ngIf="hasError('appealNote')">
          {{ getError('appealNote') }}
        </p>
      </div>
      <div *ngIf="showAppealResolution" class="field">
        <label class="label" translationEditableDirective="APPEAL_RESOLUTION">{{
          'APPEAL_RESOLUTION' | translate
        }}</label>
        <div class="control">
          <textarea
            class="textarea"
            [rows]="4"
            name="appealResolution"
            type="text"
            [ngClass]="{ 'is-danger': hasError('appealResolution') }"
            (input)="handleFieldChange($event)"
            >{{ getField(['appealResolution']) }}</textarea
          >
        </div>
        <p class="help is-danger" *ngIf="hasError('appealResolution')">
          {{ getError('appealResolution') }}
        </p>
      </div>
      <!-- <div *ngIf="showAppealNote" class="field">
        <label class="label">Field Visit</label>
        <div class="control">
          <div class="switch">
            <label>
                <input [ngClass]="{ 'is-danger': hasError('fieldVisit') }" (change)="handleFieldChange($event)" class="switch-input" name="fieldVisit" type="checkbox" />
                <div><div></div></div>
            </label>
        </div>
        </div>
        <p class="help is-danger" *ngIf="hasError('fieldVisit')">
          {{ getError("fieldVisit") }}
        </p>
      </div>
 
      <div *ngIf="showAppealNote && fieldVisit" class="field">
        <label class="label">Field Officer</label>
        <div class="control">
          <input
            class="input"
            name="fieldOfficer"
            type="text"
            [value]='getField(["fieldOfficer"])'
            [ngClass]="{ 'is-danger': hasError('fieldOfficer') }"
            (input)="handleFieldChange($event)"
            />
        </div>
        <p class="help is-danger" *ngIf="hasError('fieldOfficer')">
          {{ getError("fieldOfficer") }}
        </p>
      </div> -->
    </form>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        (click)="save(true)"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
      <button
        class="button"
        (click)="toggleModal()"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>

<div class="modal is-active" *ngIf="isFieldVisitModalOpen">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="FIELD_VISIT"
        >{{ 'FIELD_VISIT' | translate }}</span
      >
      <button
        class="delete"
        (click)="toggleFieldVisitModal()"
        aria-label="close"
        type="button"
      ></button>
    </div>
    <form [formGroup]="fieldVisitForm" class="modal-card-body">
      <div class="field">
        <label class="label" translationEditableDirective="FIELD_VISIT">{{
          'FIELD_VISIT' | translate
        }}</label>
        <div class="control">
          <div class="switch">
            <label>
              <input
                formControlName="fieldVisit"
                class="switch-input"
                name="fieldVisit"
                type="checkbox"
              />
              <div><div></div></div>
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="fieldVisitForm.get('fieldVisit').value" class="field">
        <label
          class="label"
          translationEditableDirective="FIELD_VISIT_INSTRUCTIONS"
          >{{ 'FIELD_VISIT_INSTRUCTIONS' | translate }}</label
        >
        <div class="control">
          <input
            class="input"
            [ngClass]="{ 'is-danger': fieldVisitForm.get('fieldVisitComment').invalid && fieldVisitForm.get('fieldVisitComment').touched }"
            name="fieldVisitComment"
            type="text"
            formControlName="fieldVisitComment"
          />
        </div>
        <p class="help is-danger" *ngIf="fieldVisitForm.get('fieldVisitComment').invalid && fieldVisitForm.get('fieldVisitComment').touched">
          {{ getError("fieldVisitComment") }}
        </p>
      </div>
    </form>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        (click)="saveFieldVisit()"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
      <button
        class="button"
        (click)="toggleFieldVisitModal()"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>
